<template>
  <div class="scrap">
    <assets-approvel
      :departmentId="departmentId"
      :isApprovelType="isApprovelType"
    />
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import AssetsApprovel from "@/components/assets-approvel.vue";
export default {
  components: {
    AssetsApprovel
  },

  data() {
    return {
      departmentId: 0,
      isApprovelType: 5,
    }
  },

  created() {
    config()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.scrap {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>